// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state/preferences';

const updateNextLocation = (state, action) => action.data;

export default (state = getDefaultState().nextLocation, action) => {

    const actionTypes = {
        [actions.UPDATE_USER_PREFERENCES_NEXT_LOCATION]: updateNextLocation
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};




// WEBPACK FOOTER //
// ./src/user/shared/reducers/update-next-location.js